exports.PAGES = {
    JOB_ORDERS_PAGE : 0,
    EDIT_JOB_ORDERS_PAGE : 1,
    VESSELS_PAGE : 2,
    EDIT_VESSELS_PAGE : 3,
    ADD_JOB_ORDERS_PAGE : 4,
    LOGIN_PAGE : 5,
    SIGNUP_PAGE : 6,
    VERIFY_PAGE : 7,
    SCHEDULES_PAGE : 8,
    DOCUMENTS_PAGE : 9,
    TIMESHEETS_PAGE : 10,
    EDIT_JOB_ORDERS_PAGE : 11,
    EDIT_JOB_SCHEDULES_PAGE : 12,
    SCHEDULES_VIEW_PAGE : 13,
    EMPLOYEE_HOURS_PAGE : 14,
    UNASSIGNED_DOCUMENTS_PAGE : 15,
    EDIT_DOCUMENTS_PAGE : 16,
    FORGOT_PASSWORD_PAGE : 17,
    RESET_PASSWORD_PAGE : 18,
    ADD_VESSELS_PAGE : 19,
    CUSTOM_REPORTS_PAGE : 20,
    EMPLOYEE_OVERVIEW_PAGE : 21,
    STATUS_REPORTS_PAGE : 22,
    MOBILE_SYNC_JOBORDERS : 23,
    MOBILE_SYNC_ACTIVITIES : 24,
    MOBILE_SYNC_ACTIVITYDATA : 25,
    ADD_DOCUMENTS_PAGE : 26,
    MOBILE_SYNC_JOBSCHEDULES : 27,
    MOBILE_IMAGES : 28,
    MOBILE_COLORS : 29,
    SCHEDULE_JOB_INFO : 30,
    ACTIVITIES_PAGE : 31,
    EDIT_ACTIVITIES_PAGE : 32,
    REPORT_TIMES_PAGE : 33,
    EDIT_REPORT_TIMES_PAGE : 34,
    INVOICES_PAGE : 35,
    EDIT_INVOICES_PAGE : 36,
    INVOICE_JOB_ORDER_PAGE : 37,
    INVOICE_SCHEDULE_PAGE : 38,
    INVOICE_DOCUMENT_PAGE : 39,
    INVOICE_TIMESHEET_PAGE : 40,
    INVOICE_ACTIVITY_PAGE : 41,
    SCHEDULING_PAGE : 42,
    DOCUMENT_JOB_INFO : 43,
    WO_COLORS : 44,
    VESSEL_HISTORY_PAGE : 45,
    VIEW_VESSEL_HISTORY_PAGE : 46,
    VESSEL_JOB_ORDERS_PAGE : 47,
    VESSEL_SISTER_PAGE : 48,
    VESSEL_IMO_PAGE : 49,
    SUBCONTRACTOR_HOURS_PAGE : 50,
    TECHDOCS_PAGE : 51,
    EDIT_TECHDOCS_PAGE : 52,
    ADD_TECHDOCS_PAGE : 53,
    VESSELPICS_PAGE : 54,
    PICTURES_PAGE : 55,
    ADD_VESSELPICS_PAGE : 56,
    ADD_PICTURES_PAGE : 57,
    ADD_FILES_PAGE : 58,
    FILES_PAGE : 59,
    FILES_DELETE_PAGE : 60,
    PICTURES_DELETE_PAGE : 61,
    EDIT_SUBCONTRACTOR_HOURS_PAGE : 62,
    ADD_SUBCONTRACTOR_HOURS_PAGE : 63,
    JOB_ORDER_INVOICES_PAGE : 64,
    PO_NUMBERS_PAGE : 65,
    EDIT_PO_NUMBERS_PAGE : 66,
    ADD_PO_NUMBERS_PAGE : 67,
    PO_JOBORDER_PAGE : 68,
    PO_INVOICE_PAGE : 69,
    EDIT_PO_NUMBER_JOB_ORDERS_PAGE : 70,
    JOBORDER_PO_NUMBER_PAGE : 71,
    CREATE_INVOICE_PAGE : 72,
    CREATE_INVOICE_PAGE_TIME : 73,
    CREATE_INVOICE_PAGE_MATERIAL : 74,
    CREATE_INVOICE_PAGE_PONUMBER : 75,
    CREATE_INVOICE_PAGE_COMPLETE : 76,
    CREATE_INVOICE_PAGE_ADDRESS : 77,
    CREATE_INVOICE_PAGE_HOURCALC : 78,
    CREATE_INVOICE_PAGE_MATERIALRATE : 79,
    CREATE_INVOICE_PAGE_DOCUMENTS : 80,
    CREATE_INVOICE_PAGE_ADDITIONALJOBORDERS : 81,
    ADDITIONAL_JOBORDERS_PAGE : 82,
    INVOICE_STATUS_PAGE : 83,
    JOBORDER_PORT_STAYS_PAGE : 84,
    ADD_PORT_STAYS_PAGE : 85,
    ADD_PORT_STAYS_JOBORDERS_PAGE : 86,
    CONTRACTS_PAGE : 87,
    VIEW_CONTRACTS_PAGE : 88,
    CONTRACT_JOBORDERS_PAGE : 89,
    CONTRACT_JOBORDERS_LINKED_PAGE : 90,
    CONTRACT_INVOICE_PREVIEW_PAGE : 91,
    CONTRACT_PREPARE_PAGE : 92,
    CONTRACT_DOCUMENTS_PAGE : 93,
    JOBORDER_VESSELPIC_PAGE : 94,
    VESSELHISTORY_VESSELPIC_PAGE : 95,
    LOGS_PAGE : 96,
    LOGS_NAMES_PAGE : 97,
    STATUS_GROUP_PAGE : 98,
    DASHBOARD_PAGE : 99,
    DASHBOARDS_GROUP_PAGE : 100,
    MOBILE_LOCALOFFICES : 101,
    MOBILE_PHONEDATA : 102,
    MOBILE_HASHMAP : 103,
    MOBILE_LOGOS : 104,
    MOBILE_USERIMAGES : 105,
    INVENTORY_PAGE : 106,
    INVENTORY_IMAGES_PAGE : 107,
    VIEW_INVENTORY_PAGE : 108,
    ADD_INVENTORY_PAGE : 109,
    EDIT_INVENTORY_PAGE : 110,
    SCAN_INVENTORY_PAGE_ITEM : 111,
    SCAN_INVENTORY_PAGE_BOX : 112,
    SCAN_INVENTORY_PAGE_ALT : 113,
    EDIT_INVENTORY_BOX_PAGE : 114,
    EDIT_INVENTORY_BOX_DETAIL_PAGE : 115,
    SCAN_INVENTORY_BOX_PAGE_ALT : 116,
    EMPTY_INVENTORY_BOX_PAGE : 117,
    CHECK_ITEM_DATA_PAGE : 118,
    ADD_NEW_BOX_PAGE : 119,
    VIEW_INVENTORY_TRANSACTIONS_PAGE : 120,
    JOB_ORDER_INVENTORY_PAGE : 121,
    EDIT_PO_NUMBER_PAGE : 122,
    INVENTORY_BOX_PAGE : 123,
    MOBILE_TIMESHEETS : 124,
    TIMESHEETS_B_PAGE : 125,
    ADD_ISSUES_PAGE : 126,
    ADD_ISSUES_PICTURE_PAGE : 127,
    RESOLVE_ISSUE_PAGE : 128,
    MOBILE_REMOTES : 129,
    ROLES_PAGE : 130,
    USERS_PAGE : 131,
    PERMISSIONS_PAGE : 132,
    EDIT_ROLES_PAGE : 133,
    LOCKS_PAGE : 134,
    JOB_ORDER_PARENT_PAGE : 135,
    EDIT_SERVICE_REPORT_PAGE : 136,
    EDIT_SERVICE_REPORT_PAGE_ACTIVITIES : 137,
    EDIT_SERVICE_REPORT_PAGE_REPORT_TIMES : 138,
    EDIT_SERVICE_REPORT_PAGE_FORMATS : 139,
    EDIT_SERVICE_REPORT_PAGE_MATERIALS : 140,
    EDIT_SERVICE_REPORT_PAGE_DOCUMENTS : 141,
    MOBILE_SYNC_TIMESHEETS : 142,
    MOBILE_SYNC_LOCATIONS : 143,
    MOBILE_SYNC_SETTINGS : 144,
    MOBILE_SYNC_LOGOS : 145,
    MOBILE_SYNC_DOCUMENTS : 146,
    MOBILE_SYNC_TIMECALC : 147,
    EDIT_INVOICE_PAGE : 148,
    EDIT_INVOICE_PAGE_JOBORDER : 149,
    MOBILE_SYNC_PICTURES : 150,
    MOBILE_SYNC_STAMPS : 151,
    MOBILE_LOGIN_PAGE : 152,
    EMAILS_PAGE : 153,
    EMAILS_CONTACTS_PAGE : 154,
    EMAILS_JOBORDERS_PAGE : 155,
    EDIT_WEBSITE_PAGE : 156,
    JOBORDER_COMMENTS_PAGE : 157,
    SCHEDULING_II_PAGE : 158,
    SCHEDULING_EMPLOYEE_PAGE : 159,
    ADD_INVOICE_PAGE : 160,
    JOBORDER_WECHAT_PAGE : 161,
    JOBORDER_COMMENTS_DELETE_PAGE : 162,
    LOCAL_OFFICE_FILTER_PAGE : 163,
    TIMESHEET_MAP_PAGE : 164,
    MOBILE_SYNC_COUNT : 165,
    EDIT_EMPLOYEE_PAGE : 166,
    ASSIGN_DOCUMENT_WO_PAGE : 167,
    LOGIN_TOKEN_PAGE : 168,
    EMPTY_INVENTORY_BOX_PAGE : 169,
    SCAN_BOX_ITEM : 170,
    TRIPS_PAGE : 171,
    TRIP_JOBORDERS_PAGE : 172,
    EDIT_TRIPS_PAGE : 173,
    ADD_TRIPS_PAGE : 174,
    JOBORDER_CHANGE_PAGE : 175,
    MOBILE_SYNC_PICTURES_DELETE : 176,
    MERGE_DOCUMENT_PAGE : 177,
}

exports.SUGGESTIONS = {
    JOBTYPE : 0,
    TIME : 1,
    DEPATURE_TIME : 2,
    VESSEL : 3,
    PORT : 4,
    TERMINAL : 5,
    BERTH : 6,
    SIDE : 7,
    SPO : 8,
    CUSTOMER : 9,
    PREVIOUS_PORT : 10,
    NEXT_PORT : 11,
    IN_VOYAGE : 12,
    OUT_VOYAGE : 13,
    COMMENTS : 14,
    JOB_SKILLS : 15,
    EMPLOYEE : 16,
    DURATION : 17,
    COMPLETED_TIME : 18,
    CREATED_TIME : 19,
    SCHEDULE_SOURCE : 20,
    INVOICED : 21,
    STATUS : 22,
    COMMENTS : 23,
    INVOICEDTO : 24,
    SCHEDULETYPE : 25,
    DESCRIPTION : 26,
    JOB_STATUS : 27,
    ACTIVE_EMPLOYEE : 28,
    SCHEDULE_ID : 29,
    DOCUMENT_TYPE : 30,
    VESSELNAME : 31,
    IMO : 32,
    SHIPYARD : 33,
    HULLNUMBER : 34,
    YEARBUILT : 35,
    CONTRACTID : 36,
    VESSELTYPE : 37,
    CUSTOMERCODE : 38,
    ISMMANAGER : 39,
    ALPHALINERCLASS : 40,
    FLEET : 41,
    VESSELSEGMENT : 42,
    SISTERGROUP : 43,
    VENDOR : 44,
    FROM_TIME : 45,
    TO_TIME : 46,
    NOTES : 47,
    PO_NUMBER : 48,
    WORKER_TYPE : 49,
    MATERIAL : 50,
    INVENTORY_TYPE : 51,
    MANUFACTURER : 52,
    MODEL : 53,
    QTY : 54,
    WEIGHT : 55,
    BOX : 56,
    OWNER : 57,
    JOB_ORDERS : 58,
    SERIAL_NUMBER : 59,
    INVENTORY_LOCATION : 60,
    CALLSIGN : 61,
    MMSI : 62,
    RADIO_STATUS : 63,
    CANCELLATION_REASON : 64,
    LOCAL_OFFICE: 65,
    DOCUMENT_WO_INFO: 66,
}

exports.MOBILE = {
    MOBILE_VERSION_CANDIDATE:"0.4.18",
    MOBILE_VERSION_PRODUCTION:"0.4.16",
    HASHMAP_VERSION: 0
}


//////////////////
// WEBPACK FOOTER
// ./constantsreq.js
// module id = 883
// module chunks = 0